import type { OutcomeSelection } from "./vocabulary";

// A press on the card lands its drill in the widget detail dialog: the
// chart-only presentation opens with the pressed tone / member already
// selected, so the band or member rows sit at the top and the Updates table
// discloses below them at dialog size. The card itself stays undisclosed.
//
// The card's render and the dialog's expanded render are two component
// instances; the press happens in the first and the disclosure must show in
// the second. The card stages its selection here by instance id and the
// expanded render takes it on mount, so nothing lingers past one open.
const staged = new Map<string, OutcomeSelection>();

export function stageExpandedSelection(instanceId: string, selection: OutcomeSelection): void {
  staged.set(instanceId, selection);
}

export function takeExpandedSelection(instanceId: string): OutcomeSelection | null {
  const selection = staged.get(instanceId) ?? null;
  staged.delete(instanceId);
  return selection;
}
